import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import LoadingModal from "./components/loadingModal/LoadingModal";
import { usePingQuery } from "./redux/services/crmAPI";
import { setPermissions, setStatus, setUserPermission } from "./redux/slices/statusSlice";
import Rotes from "./Rotes";

function App() {
    const dispatch = useDispatch();
    const location = useLocation();
    const isBarcode = location.pathname.includes("barcode");

    const authStatus = useSelector((state) => state.status.isAuthor);
    const [isAuth, setIsAuth] = useState(false);

    useEffect(() => {
        setIsAuth(JSON.parse(localStorage.getItem("isLoged")));
        dispatch(setStatus(isAuth));
    }, [isAuth]);

    const { data: ping, refetch: refetchPing } = usePingQuery("ping");

    useEffect(() => {
        if (ping) {
            dispatch(setPermissions(ping.permissions.map((perm) => perm.permission)));
            dispatch(setUserPermission(ping.user));
        }
    }, [ping]);

    useEffect(() => {
        const refetch = async () => {
            await refetchPing();
        };
        if (isAuth) {
            refetch();
        }
    }, [isAuth]);

    const isSomeQueryPending = useSelector((state) =>
        Object.values(state.crmAPI.queries).some((query) => query.status === "pending")
    );

    // const isPermissions = useSelector((state) => Object.values(state.crmAPI.mutations)).some(
    //     (mutation) => mutation?.error?.status === 403
    // );

    return (
        <>
            {!isBarcode && (
                <div className={authStatus ? "main-container" : null}>
                    {!isBarcode && authStatus && <Header />}
                    {isSomeQueryPending && <LoadingModal />}
                    <Rotes />
                </div>
            )}
            {isBarcode && <Rotes />}
            {!isBarcode && authStatus && <Footer />}
        </>
    );
}

export default App;
